import React, { useState } from "react";

//components
import DownloadButton from "../../../components.smart/DownloadButton";
import { CompanyFeedbackFilter } from "./CompanyFeedbackFilters";

import { SERVICE_FEEDBACK_COMPANY, getSearch } from "../../../api/services/defs/search-service";

//utils
import pubSub from "../../../utils/PubSub";
import { getFiltersForSearch } from "../utils";

import useInfoPageTemplateQueryState from "../../../pageTemplates/InfoPageTemplate/useInfoPageTemplateQueryState";

export const DownloadCompanyFeedbackCsvButton = () => {
	const [csvJobId, setCsvJobId] = useState<string | null>(null);

	const { sort, filters, searchValue } = useInfoPageTemplateQueryState<CompanyFeedbackFilter>({
		defaultSortName: "last_updated",
		defaultSortDirection: "desc",
		defaultPageNumber: 1,
	});

	const handleDownloadCsv = async () => {
		const response = await getSearch(
			SERVICE_FEEDBACK_COMPANY,
			getFiltersForSearch(searchValue, filters),
			0,
			0,
			sort,
			true
		);

		const jobID = response?.jobID;
		pubSub.publish("check async frequency", { frequency: 500 });
		setCsvJobId(jobID);
	};

	const handleClearCsvDownload = () => {
		setCsvJobId(null);
	};

	return (
		<DownloadButton
			jobID={csvJobId}
			autoDownload={true}
			onClick={handleDownloadCsv}
			onDownload={handleClearCsvDownload}
			style={{ height: 32 }}
			isHollow={true}
		>
			<span data-testid="download-csv">Download CSV</span>
		</DownloadButton>
	);
};
